/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import ArgosFlexbox from "../../../../../components/Containers/ArgosFlexbox"
import {config} from "../../../../../../AppConfig/config"
import {VEHICLE_PROGRAMS_CONSTANTS} from "../../../constants"


export interface SensingSysPerfProps {

}

export interface PerformanceRow {
  view: string
  mergeConfiguration: string
  comments: string
  bluelineId: string
  redlineId: string
  adasReportId: string
  datasetState: string
  camera: string
  radar: string
  name: string
}

export interface ModalityPerformanceCell {
  passes: number
  fails: number
}

export const generateBlueLineEndpoint = `${config.url.API_URL}${VEHICLE_PROGRAMS_CONSTANTS.itemDetails.endpoints.generateBlueLine}`
export const getPerformanceTableEndpoint = `${VEHICLE_PROGRAMS_CONSTANTS.itemDetails.endpoints.getPerformanceTable}`
export const updatePerformanceTableEndpoint = `${VEHICLE_PROGRAMS_CONSTANTS.itemDetails.endpoints.updatePerformanceTable}`
export const getReportOptionsEndpoint = `${VEHICLE_PROGRAMS_CONSTANTS.itemDetails.endpoints.getReportOptions}`
export const getViolationsReportEndpoint = `${VEHICLE_PROGRAMS_CONSTANTS.itemDetails.endpoints.getViolationsReport}`
export const getReportMetadataEndpoint = `${VEHICLE_PROGRAMS_CONSTANTS.itemDetails.endpoints.getReportMetadata}`
export const getBlueLineStatusEndpoint = `${VEHICLE_PROGRAMS_CONSTANTS.itemDetails.endpoints.getBlueLineStatus}`

export enum ELineTypes {
  RED_LINE = "red_line",
  RED_LINE_RAW_DATA = "red_line_raw_data",
  GREEN_LINE = "green_line",
  BLUE_LINE = "blue_line",
  VIOLATION_LINE = "violation_line"
}

export const idToLabelMergeConfigurationsMap: any = {
  "capability": "Capability",
  "modality": "Modality",
  "dataflow": "Data Flow",
  "safety": "Safety",
}

export const idToLabelModalitiesMap: any = {
  "camera": "Camera",
  "radar": "Radar",
}

export const idToLabelLineTypesMap = {
  [ELineTypes.RED_LINE]: "Red Line",
  [ELineTypes.RED_LINE_RAW_DATA]: "Raw Data",
  [ELineTypes.GREEN_LINE]: "Green Line",
  [ELineTypes.BLUE_LINE]: "Blue Line",
  [ELineTypes.VIOLATION_LINE]: "Violations"
}

export const idLineColorsMap = {
  [ELineTypes.RED_LINE]: "red",
  [ELineTypes.RED_LINE_RAW_DATA]: "red",
  [ELineTypes.GREEN_LINE]: "green",
  [ELineTypes.BLUE_LINE]: "blue",
  [ELineTypes.VIOLATION_LINE]: "orange"
}

export const renderPerformanceCell = (performanceData: ModalityPerformanceCell) => {
  if (performanceData === undefined) {
    return (
      <ArgosFlexbox vertical
                    alignItems="center"
      >
        <ArgosFlexbox
          style={{
            color: "black",
            fontStyle: "italic"
          }}
        >
          N/A
        </ArgosFlexbox>
      </ArgosFlexbox>
    )
  }

  const passes = performanceData.passes
  const fails = performanceData.fails
  const total = passes + fails
  const passRatio = passes / total
  const passPercentage = passRatio * 100
  const passPercentageStr = `${passPercentage.toFixed(2)}%`
  // const failStr = `Fail (${passPercentageStr})`
  const failStr = `Fail`
  let backgroundColor = ""
  let statusStr = ""


  switch (true) {
    case (passRatio < 0.8):
      backgroundColor = "black"
      statusStr = failStr
      break
    case (passRatio < 0.99):
      backgroundColor = "black"
      statusStr = failStr
      break
    case (passRatio >= 0.99):
      backgroundColor = "green"
      statusStr = "Pass"
      break
  }

  return (
    <ArgosFlexbox vertical
                  alignItems="center"
    >
      <ArgosFlexbox
        style={{
          fontWeight: "bold",
          color: backgroundColor
        }}
      >
        {statusStr}
      </ArgosFlexbox>
      <ArgosFlexbox>
        {`${passes}/${total} passed`}
      </ArgosFlexbox>
    </ArgosFlexbox>
  )
}
